import React from "react";
import {closeSnackbar, enqueueSnackbar} from "notistack";
import {IconButton} from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";

/**
 * The `Snackbar` component is a functional React component that displays a notification message using the `notistack` library.
 *
 * @param {string} message - The message to be displayed in the snackbar.
 * @param {string} variant - The variant of the snackbar, which determines its styling. Common variants include 'default', 'error', 'success', 'warning', and 'info'.
 *
 * @example
 * // As a function
 * Snackbar({message: "This is a success message!", variant: "success"})
 * 
 * // As a component
 * <Snackbar message="This is a success message!" variant="success" />
 */
export function Snackbar({message, variant}) {
    return enqueueSnackbar(message, {
        variant: variant, 
        action: (key) => (
            <IconButton aria-label="close" size="small" sx={{color: 'white'}}
                        onClick={() => closeSnackbar(key)}>
                <CancelIcon fontSize="inherit"/>
            </IconButton>
        ),
        preventDuplicate: true
    })
}